import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CpuIcon } from 'lucide-react';
interface SlideLayoutProps {
  children: React.ReactNode;
  className?: string;
  hideLogo?: boolean;
}
export const slideVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1],
      staggerChildren: 0.1
    }
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export const itemVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function SlideLayout({
  children,
  className = '',
  hideLogo = false
}: SlideLayoutProps) {
  return <motion.div variants={slideVariants} initial="initial" animate="animate" exit="exit" className={`w-full min-h-full flex flex-col items-center justify-center px-8 md:px-16 lg:px-24 py-16 relative ${className}`} data-id="element-515">
      {/* Persistent logo */}
      {!hideLogo && <div className="absolute top-5 left-6 md:left-8 flex items-center gap-2 z-20 opacity-60" data-id="element-516">
          <CpuIcon className="w-5 h-5 text-brand-teal" strokeWidth={1.5} data-id="element-517" />
          <span className="text-sm font-semibold text-brand-text tracking-tight" data-id="element-518">
            OpenFPGA
          </span>
        </div>}
      <div className="w-full max-w-6xl mx-auto relative z-10" data-id="element-519">{children}</div>
    </motion.div>;
}